(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-sc-slider]:not([data-sc-ready])').forEach((slider) => {
      slider.dataset.scReady = 'true';
      const track = slider.querySelector('[data-sc-track]');
      const slides = [...slider.querySelectorAll('[data-sc-slide]')];
      if (!track || !slides.length) return;
      let index = 0;
      let timer;
      const dots = [...slider.querySelectorAll('[data-sc-dot]')];
      const show = (next) => {
        index = (next + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          slide.classList.toggle('is-active', i === index);
          slide.setAttribute('aria-hidden', i === index ? 'false' : 'true');
        });
        dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      };
      const start = () => {
        const delay = Number(slider.dataset.autoplay || 0);
        if (delay > 0 && slides.length > 1) timer = setInterval(() => show(index + 1), delay);
      };
      slider.querySelector('[data-sc-prev]')?.addEventListener('click', () => { clearInterval(timer); show(index - 1); start(); });
      slider.querySelector('[data-sc-next]')?.addEventListener('click', () => { clearInterval(timer); show(index + 1); start(); });
      dots.forEach((dot, i) => dot.addEventListener('click', () => { clearInterval(timer); show(i); start(); }));
      slider.addEventListener('mouseenter', () => clearInterval(timer));
      slider.addEventListener('mouseleave', start);
      show(0);
      start();
    });

    root.querySelectorAll('[data-sc-rail]:not([data-sc-ready])').forEach((rail) => {
      rail.dataset.scReady = 'true';
      const track = rail.querySelector('[data-sc-rail-track]');
      if (!track) return;
      const amount = () => Math.max(track.clientWidth * .82, 280);
      rail.querySelector('[data-sc-rail-prev]')?.addEventListener('click', () => track.scrollBy({ left: -amount(), behavior: 'smooth' }));
      rail.querySelector('[data-sc-rail-next]')?.addEventListener('click', () => track.scrollBy({ left: amount(), behavior: 'smooth' }));
    });
  };
  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
